import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { TrackerListView } from '@/features/tracker/TrackerListView'
import { useViewAsId } from '@/lib/viewAs'

function Tracker() {
  const { company } = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <TrackerListView
      asUser={useViewAsId()}
      companyId={company}
      onCompanyChange={id => navigate({ search: prev => ({ ...prev, company: id || undefined }), replace: true })}
    />
  )
}

export const Route = createFileRoute('/tracker/')({
  // Staff's chosen company lives in the URL, so going back from an issue returns to the same list, and a fresh visit
  // starts on no company at all.
  validateSearch: (raw: Record<string, unknown>): { company?: string } => ({
    company: typeof raw.company === 'string' && raw.company ? raw.company : undefined,
  }),
  component: Tracker,
})
